import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";

const ContactForm = () => {
  const form = useRef();
  const [status, setStatus] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    // Altera temporariamente o valor do campo 'message' no form antes de enviar
    const formElement = form.current;
    const messageField = formElement.querySelector("textarea[name='message']");
    const fullMessage = `Nome: ${name}\nEmail: ${email}\nMensagem: ${message}`;
    messageField.value = fullMessage;

    emailjs
      .sendForm(
        "service_betoaur",
        "template_nal85f5",
        formElement, // aqui vai o form.current
        "pNjZF5-SPgUYjJ_mf"
      )
      .then(
        () => setStatus("success"),
        () => setStatus("error")
      );

    e.target.reset();
  };

  if (status) {
    setTimeout(() => setStatus(""), 3000);
  }

  return (
    <>
      <form
        ref={form}
        onSubmit={sendEmail}
        className="formContact d-flex-column"
      >
        <div className="inputsContact">
          <div className="d-flex-column">
            <label className="paragraph labelForm">Nome</label>
            <input
              className="inputDefault"
              type="text"
              placeholder="Seu nome vai aqui"
              name="user_name"
              required
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="d-flex-column">
            <label className="paragraph labelForm">E-mail</label>
            <input
              className="inputDefault"
              type="email"
              placeholder="Exemplo@email.com"
              name="user_email"
              required
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="textareaForm d-flex-column">
            <label className="paragraph labelForm">Mensagem</label>
            <textarea
              className="inputDefault"
              cols={2}
              rows={4}
              placeholder="Escreva sua mensagem..."
              name="message"
              spellCheck="true"
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
          </div>
        </div>
        <button type="submit" className="btn-white-1 buttonSendEmail">
          Enviar e-mail
        </button>
      </form>

      {status === "success" && (
        <div className="containerMessageSuccess">
          <div className="boxMessageSucces">
            <span className="material-symbols-outlined iconMesSucces">
              check
            </span>
            <div className="boxContent">
              <h2 className="titleMessageSucces">
                Mensagem enviada com sucesso!
              </h2>
              <p className="messageSucces">
                <span>{name}</span>, obrigado pelo seu contato! Recebemos sua
                mensagem e retornaremos em breve.
              </p>
            </div>
          </div>
        </div>
      )}

      {status === "error" && (
        <div className="containerMessageSuccess">
          <div className="boxMessageSucces">
            <span className="material-symbols-outlined iconMesError">
              close
            </span>
            <div className="boxContent">
              <h2 className="titleMessageSucces">Algo deu errado</h2>
              <p className="messageSucces">
                <span>{name || "Usuário"}</span>, algo inesperado aconteceu.
                Tente novamente mais tarde.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ContactForm;
